import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Button from '../../../components/common/Button';
import Spinner from '../../../components/common/Spinner';
import TextField from '../../../components/common/TextField';
import { accountDetailsRequest } from '../../../modules/account/actions';
import { getMobileNumber, isDetailsPending } from '../../../modules/account/selectors';
import { checkMobileNumber, checkMobileNumberLive } from '../../../modules/validators';
import { SETTINGS } from '../../../routes/paths';
import FormMessage from '../../FormMessage';
import { getFieldErrors } from '../../FormMessage/selectors';
import { changePhoneNumberRequest } from './actions';

export class ChangePhoneNumber extends Component {
  constructor(props) {
    super(props);

    this.handleMobileNumberChange = this.handleMobileNumberChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.state = {
      mobileNumber: '',
      mobileNumberErrors: [],
      submitDisabled: true
    };
  }

  componentDidMount() {
    const {
      onLoad = () => {
      }
    } = this.props;

    onLoad();
  }

  componentWillReceiveProps(nextProps) {
    const { externalErrors } = nextProps;
    if (externalErrors && externalErrors.mobileNumber) {
      this.setState({
        mobileNumberErrors: [externalErrors.mobileNumber]
      });
    } else {
      this.setState({
        mobileNumberErrors: []
      });
    }
  }

  handleCancel() {
    const { history } = this.props;
    history.push(SETTINGS);
  }

  handleSubmit(event) {
    event.preventDefault();
    const { mobileNumber } = this.state;
    const { submitHandler } = this.props;
    const mobileNumberErrors = checkMobileNumber(mobileNumber);
    const isMobileNumberValid = mobileNumberErrors.length === 0;

    this.setState({
      mobileNumberErrors: (!isMobileNumberValid) ? [mobileNumberErrors[0]] : []
    });

    if (isMobileNumberValid) {
      submitHandler({ mobileNumber: mobileNumber.replace(/^(44|\+44)/, '0') });
    }
  }

  handleMobileNumberChange(event) {
    const {
      currentTarget: {
        value
      }
    } = event;
    const errors = checkMobileNumberLive(value);
    const submitDisabled = checkMobileNumber(value).length !== 0;

    this.setState({
      mobileNumber: value,
      mobileNumberErrors: (errors.length) ? [errors[0]] : [],
      submitDisabled
    });
  }

  render() {
    const {
      mobileNumber,
      mobileNumberErrors,
      submitDisabled
    } = this.state;
    const {
      currentMobileNumber,
      showSpinner
    } = this.props;

    return (
      <div className="settings">
        <div className="container--fixed">
          <FormMessage className="settings__form-message" />
        </div>
        <div className="settings__content">
          <div className="container--fixed">
            <h2 className="settings__header">Your mobile number</h2>
            <p className="settings__info settings__spinner">
              {
                (showSpinner)
                  ? (<Spinner className="spinner--small" />)
                  : (currentMobileNumber)
              }
            </p>
            <p className="settings__info">
              If you have changed your mobile number, you can update it below.
            </p>

            <h4 className="change-phone-number__header">Enter your new mobile number</h4>

            <form action={this.handleSubmit}>
              <TextField
                type="tel"
                value={mobileNumber}
                hintText="e.g. 07788888888"
                onChange={e => this.handleMobileNumberChange(e)}
                errors={mobileNumberErrors}
                maxLength={13}
                disabled={showSpinner}
              />
              <Button
                className="change-phone-number__button"
                onClick={this.handleSubmit}
                disabled={showSpinner || !currentMobileNumber || submitDisabled}
              >
                Submit
              </Button>
            </form>
            <Button
              className="change-phone-number__button button--secondary"
              onClick={this.handleCancel}
            >
              Return to account settings
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

ChangePhoneNumber.propTypes = {
  externalErrors: PropTypes.object,
  currentMobileNumber: PropTypes.string,
  showSpinner: PropTypes.bool,
  onLoad: PropTypes.func,
  submitHandler: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  externalErrors: getFieldErrors(state),
  currentMobileNumber: getMobileNumber(state),
  showSpinner: isDetailsPending(state)
});

const mapDispatchToProps = {
  onLoad: accountDetailsRequest,
  submitHandler: changePhoneNumberRequest
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ChangePhoneNumber));
